import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { user, loading, requiresAuth } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-container">
        <span style={{ color: 'var(--on-surface-variant)' }}>Loading...</span>
      </div>
    );
  }

  // If auth is disabled on the server, render children without checking user
  if (!requiresAuth()) {
    return <>{children}</>;
  }

  if (!user) {
    return (
      <Navigate
        to={`/login?returnTo=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  if (requireAdmin && user.role !== 'admin' && !user.is_admin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
